import { render } from "./LiquidacionInfo.vue?vue&type=template&id=5840d2b3&scoped=true"
import script from "./LiquidacionInfo.vue?vue&type=script&lang=js"
export * from "./LiquidacionInfo.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./LiquidacionInfo.vue?vue&type=style&index=1&id=5840d2b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5840d2b3"]])

export default __exports__